<template>
  <div class="content5">
    <div class="api-title">
      <svg
        width="38"
        height="42"
        viewBox="0 0 38 42"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M35.9999 11.5554L18.9999 20.9999M18.9999 20.9999L1.99993 11.5554M18.9999 20.9999L19 39.9999M37 29.117V12.8828C37 12.1975 37 11.8549 36.899 11.5493C36.8097 11.2789 36.6637 11.0308 36.4707 10.8214C36.2526 10.5847 35.9531 10.4183 35.3541 10.0855L20.5541 1.86329C19.9869 1.54817 19.7032 1.39062 19.4029 1.32884C19.1371 1.27417 18.8629 1.27417 18.5971 1.32884C18.2968 1.39062 18.0132 1.54817 17.4459 1.86329L2.64594 10.0855C2.04689 10.4183 1.74737 10.5847 1.52927 10.8214C1.33632 11.0308 1.19029 11.2789 1.10097 11.5493C1 11.8549 1 12.1975 1 12.8828V29.117C1 29.8023 1 30.145 1.10097 30.4506C1.19029 30.7209 1.33632 30.9691 1.52927 31.1785C1.74737 31.4151 2.0469 31.5815 2.64594 31.9143L17.4459 40.1366C18.0132 40.4517 18.2968 40.6092 18.5971 40.671C18.8629 40.7257 19.1371 40.7257 19.4029 40.671C19.7032 40.6092 19.9869 40.4517 20.5541 40.1366L35.3541 31.9143C35.9531 31.5815 36.2526 31.4151 36.4707 31.1785C36.6637 30.9691 36.8097 30.7209 36.899 30.4506C37 30.145 37 29.8023 37 29.117Z"
          stroke="#31006F"
          stroke-width="2"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
      </svg>
      <h5>ربط المحادثات</h5>
    </div>
    <Tabs :selected="0">
      <Tab title="محادثة الطرد">
        <link-api
          :link="linkOrderMessages"
          :success="successOrderMessages"
          :apiCode="apiCodeOrderMessages"
          :data="dataOrderMessages"
        />
      </Tab>
      <Tab title="الرد علي محادثة الطرد">
        <link-api
          :link="linkOrderPushMessage"
          :success="successOrderPushMessage"
          :apiCode="apiCodeOrderPushMessage"
          :data="dataOrderPushMessage"
        />
      </Tab>
      <Tab title="كل محادثات الطرود">
        <link-api
          :link="linkOrderConversations"
          :success="successOrderConversations"
          :apiCode="apiCodeOrderConversations"
          :data="dataOrderConversations"
        />
      </Tab>
      <Tab title="محادثة المهمة">
        <link-api
          :link="linkMissionMessages"
          :success="successMissionMessages"
          :apiCode="apiCodeMissionMessages"
          :data="dataMissionMessages"
        />
      </Tab>
      <Tab title="الرد علي محادثة المهمة">
        <link-api
          :link="linkMissionPushMessage"
          :success="successMissionPushMessage"
          :apiCode="apiCodeMissionPushMessage"
          :data="dataMissionPushMessage"
        />
      </Tab>
      <Tab title="كل محادثات المهام">
        <link-api
          :link="linkMissionConversations"
          :success="successMissionConversations"
          :apiCode="apiCodeMissionConversations"
          :data="dataMissionConversations"
        />
      </Tab>
      <Tab title="محادثة التذكرة">
        <link-api
          :link="linkTicketShow"
          :success="successTicketShow"
          :apiCode="apiCodeTicketShow"
          :data="dataTicketShow"
        />
      </Tab>
      <Tab title="الرد علي التذكرة">
        <link-api
          :link="linkTicketReply"
          :success="successTicketReply"
          :apiCode="apiCodeTicketReply"
          :data="dataTicketReply"
        />
      </Tab>
      <Tab title="كل محادثات التذاكر">
        <link-api
          :link="linkTicketConversations"
          :success="successTicketConversations"
          :apiCode="apiCodeTicketConversations"
          :data="dataTicketConversations"
        />
      </Tab>
    </Tabs>
  </div>
</template>

<script>
import LinkApi from "@/views/components/LinkApi.vue";
import Tabs from "@/layouts/components/Tabs.vue";
import Tab from "@/layouts/components/Tab.vue";

export default {
  name: "linkWithApisConversations",
  data() {
    const apiToken = JSON.parse(localStorage.getItem("userData")).apiToken;

    return {
      // ================= ORDER CHAT =================
      linkOrderMessages: "messages",
      apiCodeOrderMessages: `{"authentication_key": "${apiToken}",
      "order_code": "29018799"
      }`,
      dataOrderMessages: [
        {
          key: "authentication_key",
          value: apiToken,
          descryption: "مفتاح رئيسي",
          mandatory: "نعم",
          class: "yes",
        },
        {
          key: "order_code",
          value: "29018799",
          descryption: "كود الطلب (أو استخدم id بدلاً منه)",
          mandatory: "نعم",
          class: "yes",
        },
      ],
      successOrderMessages: `{
        "success": 1,
        "code": "29018799",
        "receiver": "احمد حسن",
        "captain": "لا يوجد",
        "branch": "لا يوجد",
        "client": "احمد",
        "client_status": 7,
        "can_send": true,
        "messages": [
          {
            "id": 501,
            "message": "الطرد وصل امتي؟",
            "your_message": 0,
            "sender_name": "احمد",
            "created_at": "2026-09-01 12:30:00"
          }
        ]
      }`,
      linkOrderPushMessage: "push-message",
      apiCodeOrderPushMessage: `{"authentication_key": "${apiToken}",
      "order_code": "29018799",
      "message": "تمام هيوصل بكرة الصبح"
      }`,
      dataOrderPushMessage: [
        {
          key: "authentication_key",
          value: apiToken,
          descryption: "مفتاح رئيسي",
          mandatory: "نعم",
          class: "yes",
        },
        {
          key: "order_code",
          value: "29018799",
          descryption: "كود الطلب (أو استخدم id بدلاً منه)",
          mandatory: "نعم",
          class: "yes",
        },
        {
          key: "message",
          value: "تمام هيوصل بكرة الصبح",
          descryption: "نص الرد المراد إرساله في محادثة الطرد",
          mandatory: "نعم",
          class: "yes",
        },
      ],
      successOrderPushMessage: `{
        "success": 1,
        "message": "تمت العملية بنجاح"
      }`,
      linkOrderConversations: "order-conversations",
      apiCodeOrderConversations: `{"authentication_key": "${apiToken}"}`,
      dataOrderConversations: [
        {
          key: "authentication_key",
          value: apiToken,
          descryption: "مفتاح رئيسي",
          mandatory: "نعم",
          class: "yes",
        },
        {
          key: "page",
          value: "2",
          descryption:
            "رقم الصفحة (اختياري). الصفحة الواحدة بترجع 15 محادثة كحد أقصى. أول استدعاء من غير page بيرجع أحدث 15 محادثة + max_message_id",
          mandatory: "لا",
          class: "no",
        },
        {
          key: "max_message_id",
          value: "532",
          descryption:
            "مطلوب فقط لما بترسل page (رقم أعلى رسالة من أول استدعاء)، بيستخدم كمرجع ثابت للترقيم بين الصفحات",
          mandatory: "لا (إلا مع page)",
          class: "no",
        },
        {
          key: "is_read",
          value: "0",
          descryption: "فلترة حسب حالة القراءة: 0 = غير مقروءة، 1 = مقروءة (اختياري)",
          mandatory: "لا",
          class: "no",
        },
      ],
      successOrderConversations: `{
        "success": 1,
        "max_message_id": 532,
        "conversations": [
          {
            "id": 29018799,
            "receiver": "احمد حسن",
            "code": "29018799",
            "message": "الطرد وصل امتي؟",
            "last_message_date": "2026-09-01 12:30:00",
            "your_message": 0,
            "is_read": 0,
            "client_status": 7
          }
        ]
      }`,
      // ================= MISSION CHAT =================
      linkMissionMessages: "mission-messages",
      apiCodeMissionMessages: `{"authentication_key": "${apiToken}",
      "mission_code": "1024"
      }`,
      dataMissionMessages: [
        {
          key: "authentication_key",
          value: apiToken,
          descryption: "مفتاح رئيسي",
          mandatory: "نعم",
          class: "yes",
        },
        {
          key: "mission_code",
          value: "1024",
          descryption: "كود المهمة (أو استخدم id بدلاً منه)",
          mandatory: "نعم",
          class: "yes",
        },
      ],
      successMissionMessages: `{
        "success": 1,
        "code": "1024",
        "captain": "محمود علي",
        "client": "احمد",
        "branch": "الضبعة-الرئيسي",
        "can_send": true,
        "status": 2,
        "type": 1,
        "messages": [
          {
            "id": 12,
            "message": "المهمة هتتنفذ امتي؟",
            "your_message": 0,
            "sender_name": "احمد",
            "created_at": "2026-09-01 09:10:00"
          }
        ]
      }`,
      linkMissionPushMessage: "mission-push-message",
      apiCodeMissionPushMessage: `{"authentication_key": "${apiToken}",
      "mission_code": "1024",
      "message": "هنبدأ خلال ساعة"
      }`,
      dataMissionPushMessage: [
        {
          key: "authentication_key",
          value: apiToken,
          descryption: "مفتاح رئيسي",
          mandatory: "نعم",
          class: "yes",
        },
        {
          key: "mission_code",
          value: "1024",
          descryption: "كود المهمة (أو استخدم id بدلاً منه)",
          mandatory: "نعم",
          class: "yes",
        },
        {
          key: "message",
          value: "هنبدأ خلال ساعة",
          descryption: "نص الرد المراد إرساله في محادثة المهمة",
          mandatory: "نعم",
          class: "yes",
        },
      ],
      successMissionPushMessage: `{
        "success": 1,
        "message": "تمت العمليه بنجاح"
      }`,
      linkMissionConversations: "mission-conversations",
      apiCodeMissionConversations: `{"authentication_key": "${apiToken}"}`,
      dataMissionConversations: [
        {
          key: "authentication_key",
          value: apiToken,
          descryption: "مفتاح رئيسي",
          mandatory: "نعم",
          class: "yes",
        },
        {
          key: "page",
          value: "2",
          descryption:
            "رقم الصفحة (اختياري). الصفحة الواحدة بترجع 15 محادثة كحد أقصى. أول استدعاء من غير page بيرجع أحدث 15 محادثة + max_message_id",
          mandatory: "لا",
          class: "no",
        },
        {
          key: "max_message_id",
          value: "210",
          descryption:
            "مطلوب فقط لما بترسل page (رقم أعلى رسالة من أول استدعاء)، بيستخدم كمرجع ثابت للترقيم بين الصفحات",
          mandatory: "لا (إلا مع page)",
          class: "no",
        },
        {
          key: "is_read",
          value: "0",
          descryption: "فلترة حسب حالة القراءة: 0 = غير مقروءة، 1 = مقروءة (اختياري)",
          mandatory: "لا",
          class: "no",
        },
      ],
      successMissionConversations: `{
        "success": 1,
        "max_message_id": 210,
        "conversations": [
          {
            "id": 1024,
            "code": "1024",
            "status": 2,
            "message": "المهمة هتتنفذ امتي؟",
            "last_message_date": "2026-09-01 09:10:00",
            "your_message": 0,
            "is_read": 0
          }
        ]
      }`,
      // ================= TICKETS CHAT =================
      linkTicketShow: "ticket",
      apiCodeTicketShow: `{"authentication_key": "${apiToken}",
      "ticket_id": 55
      }`,
      dataTicketShow: [
        {
          key: "authentication_key",
          value: apiToken,
          descryption: "مفتاح رئيسي",
          mandatory: "نعم",
          class: "yes",
        },
        {
          key: "ticket_id",
          value: "55",
          descryption: "id التذكرة",
          mandatory: "نعم",
          class: "yes",
        },
      ],
      successTicketShow: `{
        "success": 1,
        "feed": {
          "id": 55,
          "status": 2,
          "type": 2,
          "description": "الطرد وصل تالف",
          "created_at": "2026-08-30 10:00:00",
          "replies": [
            {
              "id": 101,
              "ticket_id": 55,
              "is_client_message": 1,
              "message": "الطرد وصل تالف",
              "created_at": "2026-08-30 10:00:00"
            },
            {
              "id": 102,
              "ticket_id": 55,
              "is_client_message": 0,
              "message": "تم فتح تحقيق في الموضوع",
              "created_at": "2026-08-30 11:00:00"
            }
          ]
        },
        "error_msg": "",
        "errors": []
      }`,
      linkTicketReply: "ticket-reply",
      apiCodeTicketReply: `{"authentication_key": "${apiToken}",
      "ticket_id": 55,
      "message": "شكرا لتفهمكم، تم استرجاع المبلغ"
      }`,
      dataTicketReply: [
        {
          key: "authentication_key",
          value: apiToken,
          descryption: "مفتاح رئيسي",
          mandatory: "نعم",
          class: "yes",
        },
        {
          key: "ticket_id",
          value: "55",
          descryption: "id التذكرة (لازم تكون تذكرة تابعة لنفس العميل)",
          mandatory: "نعم",
          class: "yes",
        },
        {
          key: "message",
          value: "شكرا لتفهمكم، تم استرجاع المبلغ",
          descryption: "نص الرد المراد إرساله علي التذكرة",
          mandatory: "نعم (أو أرسل image بدلاً منه)",
          class: "yes",
        },
      ],
      successTicketReply: `{
        "success": 1,
        "feed": {
          "id": 103,
          "ticket_id": 55,
          "is_client_message": 1,
          "message": "شكرا لتفهمكم، تم استرجاع المبلغ",
          "created_at": "2026-09-01 09:30:00"
        },
        "error_msg": "",
        "errors": []
      }`,
      linkTicketConversations: "ticket-conversations",
      apiCodeTicketConversations: `{"authentication_key": "${apiToken}"}`,
      dataTicketConversations: [
        {
          key: "authentication_key",
          value: apiToken,
          descryption: "مفتاح رئيسي",
          mandatory: "نعم",
          class: "yes",
        },
        {
          key: "page",
          value: "2",
          descryption:
            "رقم الصفحة (اختياري). الصفحة الواحدة بترجع 10 تذاكر كحد أقصى",
          mandatory: "لا",
          class: "no",
        },
      ],
      successTicketConversations: `{
        "success": 1,
        "feed": {
          "current_page": 1,
          "per_page": 10,
          "last_page": 3,
          "total": 27,
          "data": [
            {
              "id": 55,
              "status": 2,
              "type": 2,
              "description": "الطرد وصل تالف",
              "last_message_date": "2026-09-01 09:30:00",
              "replies": []
            }
          ]
        },
        "error_msg": "",
        "errors": []
      }`,
    };
  },
  components: {
    LinkApi,
    Tabs,
    Tab,
  },
};
</script>

<style lang="scss" scoped>
@import "@/assets/scss/vuexy/_setting.scss";
</style>
